<template lang="pug">
  #app(ref="app")
    router-view
    //-header-component
    //-footer-component
    //-portrait-warning(v-if="isMobile")
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import ResizeService from 'src/services/ResizeService'
  import SwipeableUIService from 'src/services/SwipeableUIService'

  import HeaderComponent from '@/components/Header'
  import FooterComponent from '@/components/Footer'
  //import PortraitWarning from 'src/components/unsupported/PortraitWarning'

  // import FontTest from 'src/components/_utils/FontTest'
  // import Debug from 'src/components/_utils/Debug'


  export default {
    name: 'app',
    components: {
      HeaderComponent,
      FooterComponent,
      //PortraitWarning
      // FontTest,
      // Debug,
    },
    computed: {
      ...mapState('browser', ['isMobile']),
    },
    beforeMount () {
      // listen to resize service and update the store with changes
      ResizeService.on(ResizeService.EVENTS.RESIZE, this.resize)
      this.resize()
    },
    mounted() {
      // FORCE LANDSCAPE
      // if (this.isMobile) {
      //   ResizeService.enableForceLandscape(this.$refs.app)
      // }

      // RIGHT CLICK CONTEXT MENU
      // window.addEventListener('contextmenu', (e) => {
      //   e.preventDefault()
      // })
      this.resize()
    },
    methods: {
      ...mapMutations('browser', [
        'setDevice',
        'setScale',
        'setFontSize',
        'setDimensions'
      ]),
      resize () {
        // put these in the store so we don't need to manually
        // listen to ResizeService everytime we want to react to
        // device/scale/size changes

        console.log('app: resize')

        this.setDevice(ResizeService.deviceType)
        this.setScale(ResizeService.scale)
        this.setFontSize(ResizeService.fontSize)
        this.setDimensions({
          width: ResizeService.width,
          height: ResizeService.height
        })

        if(this.$refs.app){
          //if(ResizeService.env.ios_safari){
          //this.$refs.app.style.top = window.scrollY + "px"
          // }
          this.$refs.app.style.height = window.innerHeight + "px"
        }
      }
    },
  }
</script>

<style lang="sass">
  @import "src/styles/base.sass"

  #app
    //+full()
    top: 0px
    left: 0px
    position: fixed
    width: 100vw
    height: 200vh
    overflow: hidden

    .mobile &
      position: fixed
      height: 100%

    .mobile.facebook &
      position: fixed
      height: 100%

</style>
